export enum FilterOperatorAbbreviations {
	EQUAL = 'e',
	UNEQUAL = 'ne',
	GREATER = 'gt',
	SMALLER = 'lt',
	CONTAINS = 'contains',
}
